/**
 * Google Material Symbols icon names
 * Use with the Icon component: <Icon name={iconNames.home} />
 *
 * Icon names reference: https://fonts.google.com/icons
 */
export const iconNames = {
  // Navigation
  arrowBack: "arrow_back",
  arrowForward: "arrow_forward",
  menu: "menu",
  close: "close",
  chevronLeft: "chevron_left",
  chevronRight: "chevron_right",
  chevronDown: "keyboard_arrow_down",
  chevronUp: "keyboard_arrow_up",
  expandMore: "expand_more",
  expandLess: "expand_less",
  unfoldMore: "unfold_more",

  // Actions
  add: "add",
  remove: "remove",
  edit: "edit_square",
  delete: "delete",
  save: "save",
  copy: "content_copy",
  paste: "content_paste",
  refresh: "refresh",
  sync: "sync",
  undo: "undo",
  redo: "redo",

  // Files & Folders
  folder: "folder",
  folderOpen: "folder_open",
  createFolder: "create_new_folder",
  file: "description",
  fileText: "article",
  addFile: "note_add",
  audioFile: "audio_file",
  upload: "upload",
  download: "download",

  // Media
  play: "play_arrow",
  pause: "pause",
  mic: "mic",
  video: "videocam",
  image: "image",
  photo: "photo",
  volume: "volume_up",

  // UI Elements
  search: "search",
  settings: "settings",
  moreVertical: "more_vert",
  moreHorizontal: "more_horiz",
  calendar: "calendar_today",
  clock: "schedule",
  filter: "filter_list",
  sort: "sort",

  // Status & Alerts
  check: "check",
  checkCircle: "check_circle",
  info: "info",
  warning: "warning",
  alertTriangle: "warning",
  error: "error",
  help: "help",
  bug: "bug_report",

  // User & Account
  user: "person",
  person: "person",
  logout: "logout",
  login: "login",
  dashboard: "dashboard",
  admin: "admin_panel_settings",
  people: "people",
  personAdd: "person_add",
  block: "block",
  business: "business",

  // Communication
  mail: "mail",
  send: "send",
  loading: "progress_activity",
  share: "share",
  message: "sms",
  chat: "chat",

  // Toggle & Select
  radioButtonUnchecked: "radio_button_unchecked",
  radioButtonChecked: "radio_button_checked",
  checkboxUnchecked: "check_box_outline_blank",
  checkboxChecked: "check_box",

  // Layout
  viewList: "view_list",
  viewModule: "view_module",
  viewGrid: "grid_view",

  // Special
  layers: "layers",
  stack: "layers",
  stackGroup: "stack_group",
  trash: "delete",
  restore: "restore_from_trash",
  autoAwesome: "auto_awesome",

  // Theme
  lightMode: "light_mode",
  darkMode: "dark_mode",

  // Text Formatting
  formatBold: "format_bold",
  formatItalic: "format_italic",
  formatUnderlined: "format_underlined",

  // Drag & Drop
  dragIndicator: "drag_indicator",
  dragHandle: "drag_handle",

  // Move actions
  moveUp: "move_up",
  moveDown: "move_down",
  moveToInbox: "move_to_inbox",
  outputCircle: "output_circle",
  merge: "merge",

  // Additional Icons
  home: "home",
  key: "key",
  externalLink: "open_in_new",
  language: "language",
  monitorPlay: "smart_display",
  moveRight: "keyboard_arrow_right",
  chevronsLeft: "keyboard_double_arrow_left",
  chevronsRight: "keyboard_double_arrow_right",
  chevronsUp: "keyboard_double_arrow_up",
  chevronsDown: "keyboard_double_arrow_down",
  construction: "construction",
  database: "database",
  pin: "push_pin",
  pinOff: "keep_off",
  history: "history",

  // Support
  support: "confirmation_number",

  // Cloud & Storage
  cloud: "cloud",
  cloudUpload: "cloud_upload",
  cloudDownload: "cloud_download",

  // Code
  code: "code",

  // Fullscreen
  fullscreen: "fullscreen",
  fullscreenExit: "fullscreen_exit",

  // Document Types
  pdf: "picture_as_pdf",
  recording: "mic",
  text: "article",
} as const;

export type IconName = typeof iconNames[keyof typeof iconNames];
